import { clearSubscriptionClientHints } from "./subscriptionStorage";

/** Bearer token for this browser only (localStorage). Email and account live on the server. */
const STORAGE_KEY = "rareRolesAccessToken";

export function getAccessToken() {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setAccessToken(token) {
  if (typeof window === "undefined") return;
  try {
    if (token) localStorage.setItem(STORAGE_KEY, token);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function clearAccessToken() {
  setAccessToken(null);
  clearSubscriptionClientHints();
}
